import { ParseObject } from './parse-object';

import { FileRef } from './file-ref';

export class Language extends ParseObject {
  public static readonly CLASS_NAME = 'Language';
  public static readonly CODE_KEY = 'code';
  public static readonly NAME_KEY = 'name';
  public static readonly FLAG_KEY = 'flag';

  public static readonly DEFAULT_LANG = 'en';

  constructor() {
    super(Language.CLASS_NAME);
  }

  public get code(): string {
    return this.get(Language.CODE_KEY);
  }

  public set code(code: string) {
    this.set(Language.CODE_KEY, code);
  }

  public get name(): string {
    return this.get(Language.NAME_KEY);
  }

  public set name(name: string) {
    this.set(Language.NAME_KEY, name);
  }

  public get flag(): FileRef {
    return this.get(Language.FLAG_KEY);
  }

  public set flag(flag: FileRef) {
    this.set(Language.FLAG_KEY, flag);
  }
}

Parse.Object.registerSubclass(Language.CLASS_NAME, Language);



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/language.ts